import React, { useState } from "react";
import Paragraphs from "components/Paragraphs";

const LIMIT = 7;

const DEFAULT_TITLE = "Possible enum values";

const EnumsList = ({ title = DEFAULT_TITLE, list = [] }) => {
  const listCount = list.length;
  const isLimitBound = listCount > LIMIT;
  const [canShow, setCanShow] = useState(listCount > LIMIT);
  const limitedList = canShow ? list.slice(0, LIMIT) : list;
  const remCount = Math.abs(listCount - LIMIT);
  let triggerLabel = `${canShow ? "Show" : "Hide"} ${remCount} ${
    canShow ? "more" : ""
  }`.trim();

  return (
    <div className="flex flex-column">
      {title && <div className="pa2 f6 fw5 pointer">{title}</div>}
      <ul className="ma0 pa0 list">
        {limitedList.map(({ id, paragraphs }, listIx) => {
          return (
            <li key={`${id}-${listIx}`} className="bt hairline-1">
              <div className="pa2 w-100">
                <div
                  style={{ width: "fit-content" }}
                  className="token-monospace f5 ba br1 hairline-1"
                >
                  {id}
                </div>
                {paragraphs && paragraphs.length > 0 && (
                  <div className="pt1">
                    <Paragraphs paragraphs={paragraphs} />
                  </div>
                )}
              </div>
            </li>
          );
        })}
      </ul>
      {isLimitBound && (
        <div
          className="w-100 pa2 bt hairline-1 bg-white--hover pointer"
          onClick={() => {
            setCanShow(!canShow);
          }}
        >
          <div className="f7 fw5">{triggerLabel}</div>
        </div>
      )}
    </div>
  );
};

export default EnumsList;
